import { render, staticRenderFns } from "./WikiStructureNodeTree.vue?vue&type=template&id=06c5d51d&scoped=true"
import script from "./WikiStructureNodeTree.vue?vue&type=script&lang=js"
export * from "./WikiStructureNodeTree.vue?vue&type=script&lang=js"
import style0 from "./WikiStructureNodeTree.vue?vue&type=style&index=0&id=06c5d51d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c5d51d",
  null
  
)

export default component.exports